import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InvoicelistComponent } from '../invoicelist/invoicelist.component'
import { InvoicedescriptionComponent } from '../invoicedescription/invoicedescription.component';
import { SharedServiceService } from '../shared/shared-service.service';
import { LanguageService } from '../providers/lang.service';
import { CustomStorage } from '../providers/Custom-storage.service';
import { Constant } from '../Constant';
import { RestApiServices } from '../providers/rest.service';
import { Router } from '@angular/router';
import { LoaderComponent } from '../loader/loader.component';
import { NgForm } from '@angular/forms';
import { Http } from '@angular/http';
@Component({
  selector: 'collect',
  templateUrl: './collectpayment.component.html',
  styleUrls: ['./collectpayment.component.css']
})
export class CollectpaymentComponent implements OnInit {
  IsHidden = true;
  paymentsuccessDialog: boolean = false;
  paymentfailDialog: boolean = false;
  output;
  errorMsg: string;
  errorDialog: boolean
  collectDialog:boolean;
  currentDate: Date = new Date()
  date: string
  amountOnline: number = 0;
  customerdetailsData: any;
  availableCredit;
  creditLimit;
  amtToBePaid: any = [];
  totalAmtToBePaid = 0;
  totalOrders: any = [];
  totalOrderNumbers: number = 0;
  valid_amount = false
  avl_crdt: string = ''; crdt_lmt: string = ''; total_amt: string = ''; pymt_dt: string = ''; pymt_mthd: string = '';
  lbl_amount: string = ''; collect_payment: string = ""; add_payment: string = ""; invoice: string = "";
  total_collected: string = ""; collect_text: string = ""; online_txt: string = ""; amount_check: string= ""
  pymt_succful: string; lbl_ok: string = "";


  online_amount: any = 0; selectedvalue: string = ""; lbl_selected: string = ""; actual_online_amount: any = 0;
  ordersummary: string = ""; sub_toal: string = ""; shipping_handling: string = ""; clear: string = "";
  tax_amount: string = ""; order_total: string = ""; order_submit: string = ""; payment_method: string = "";
  order_review: string = ""; order_complete: string = ""; order_terms: string = "";
  cash: string = ""; check: string = "";  amount: string = ""; credit_limit: String = "";
  addpayment_method: string = ""; availablecr: string = ""; shippinginfo: string = "";
  billinginfo: string = ""; item_number: string = ""; quantity: string = ""; items: string = "";
  cartItems = []; primary: string = ""; checkout: string = ""; addsignature: string = "";
  city_tax: string = ""; state_tax: string = ""; valid_name: string = ""; signee_name: string = "";
  po_required: string = ""; item_not_exist: string = ""; amount_check_more: string = ""
  invalid_pymt_mthd: string = ""; add_sign: string = ""; invoice_txt: string = "";
  totalItems: number;  po_number: string = ""; name_text: string = ""; order_msg1: string = "";
  order_msg2: string = ""; lbl_uom: string = ""; lbl_qty: string = "";
  lbl_yes: string = ""; lbl_no: string = ""; lbl_insuff: string = "";
  checkoutdata = []; lbl_onlineexceed: string = ""; lbl_less: string = ""; lbl_remain: string = "";
  usrname: string = ""; pdfnot_avail: string = ""; lbl_noitem: string = ""; lbl_openpdf: string = "";
  isName = false; lbl_lesspay: string = "";

  txt_cardnumber: string = ""; txt_expirydate: string = ""; txt_cardcode: string = "";
  lbl_cardnumber: string = "";lbl_month: string = "";lbl_year: string = "";lbl_cardcode: string = "";
  isPonumber = false
  submitted = false;

  formattedAmount: string = '0';
  value: any;
  isNameValid = false;
  ermsg: string
  displaymessage: boolean = false;
  itemsmessage: boolean = false;
  wasClicked: boolean = false
  cardnumDialog: boolean = false;
  monthDialog: boolean = false;
  yearDialog: boolean = false;
  cardcodeDialog: boolean = false;  
  poMatch: boolean;
  cardnumber: number;
  expirydate: number;
  cardcode: number;
  onlinealert: boolean = false;
  InvoiceValCheck: boolean = false;
  checkamount: boolean = false;
  successMessage; string;
  checkoutDialog: boolean = false;
  greatermessage: boolean = false;
  userName: string
  myDate = new Date();
  order_number;
  remainamt;
  timeStamp = new Date().getTime().toString();
  poNumber: string = null;
  totalorderamt1: number;
  totalorderamt: number;
  online_payment = this.totalorderamt;
  selectedMonth: any =0;
  selectedYear: any =0;
  @ViewChild('ngForm') signupForm: NgForm;
  ipaddr:any;
  years:any = [];
  constructor(private http: Http, private location: Location, private localStorage: CustomStorage, private sharedservice: SharedServiceService, private langService: LanguageService, private restApi: RestApiServices, private router: Router) { }

  ngOnInit() {

    var date = new Date();
    var year = date.getFullYear();

    for (var i = year; i < year + 5; i++) {
      this.years.push(i);   
    }
    // console.log(this.years)

    this.http.get('https://ipapi.co/json/').subscribe(res => {
       // console.log(JSON.stringify(res.json(), null, 2));
         this.ipaddr = res.json();
      });

    var months = []

    this.langService.getSelectedLanguage().subscribe(lang => {
      if (lang[0].languageId === '0') {
        months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
      else
        months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
      
        this.date = months[this.currentDate.getMonth()] + " " + this.currentDate.getDate() + ", " + this.currentDate.getFullYear()

    })
    // this.currentDate=date.toString()
    this.langService.getJson().subscribe(data => {
      this.setLabels();
      this.localStorage.getItem(Constant.KEY_CUSTOMER).subscribe(result => {
        this.customerdetailsData = result.response.data;
        this.availableCredit = this.customerdetailsData.available_credit;
        this.creditLimit = this.customerdetailsData.credit_limit;
      });
    });

    //  this.amtToBePaid = this.sharedservice.getInvoiceAmount()
    this.localStorage.getItem('payAmt').subscribe(res => {
      if(res){
      this.totalOrders = res;
      this.totalOrderNumbers = res.length;
      for (let i = 0; i < res.length; i++) {
        this.totalAmtToBePaid += res[i].outstanding
      }
    
      }
      // this.totalAmtToBePaid = 
      this.amountOnline=   this.totalAmtToBePaid;
    })

    let paymentMethodSetup = localStorage.getItem('PaymentMethodSetup');
    document.getElementById("noPaymentMethod").style.visibility = "hidden";
    if(paymentMethodSetup == "no") {
      document.getElementById("paymentMethodSetup").style.visibility = "hidden";
        document.getElementById("noPaymentMethod").style.visibility = "visible";
        document.getElementById("online").classList.remove("active");
      
    } else {
      setTimeout(() => {
        document.getElementById("paymentMethodSetup").style.visibility = "visible";
      }, 200);
    }
  }

  monthChanged(selectedmonth) {
    this.selectedMonth = selectedmonth;
  }

  yearChanged(selectedyear) {
    this.selectedYear = selectedyear;
  }

  onlynumber(event) {
    var key = event.charCode ? event.charCode : event.keyCode;
    if (key >= 48 && key <= 57) {
      return true;
    }
    return false;
  }

  setLabels() {
    this.langService.getLangLabelValue("LblAvailableCredit").then(res => {
      this.avl_crdt = res
    });
    this.langService.getLangLabelValue("LblCreditLimit").then(res => {
      this.crdt_lmt = res
    });
    this.langService.getLangLabelValue("LblTotal").then(res => {
      this.total_amt = res
    });
    this.langService.getLangLabelValue("LblPaymentDate").then(res => {
      this.pymt_dt = res
    });
    this.langService.getLangLabelValue("LblPaymentMethod").then(res => {
      this.pymt_mthd = res

    });
    this.langService.getLangLabelValue("LblAmount").then(res => {
      this.lbl_amount = res
    });
    this.langService.getLangLabelValue("LblCollectPayment").then(res => {
      this.collect_payment = res
    });
    this.langService.getLangLabelValue("LblAddPaymentMethod").then(res => {
      this.add_payment = res
    });
    this.langService.getLangLabelValue("LblInvoice").then(res => {
      this.invoice = res
    });
    this.langService.getLangLabelValue("LblTotalCollectedAmount").then(res => {
      this.total_collected = res
    });
    this.langService.getLangLabelValue("LblCollect").then(res => {
      this.collect_text = res
    });
    this.langService.getLangLabelValue("LblOnline").then(res => {
      this.online_txt = res
    });
    this.langService.getLangLabelValue("LblEnteredAmtCantBeLesser").then(res => {
      this.amount_check = res
    });
    this.langService.getLangLabelValue("LblPaymentMadeSuccesfully").then(res => {
      this.pymt_succful = res
    });
    this.langService.getLangLabelValue("Lblok").then(res => {
      this.lbl_ok = res
    });

    this.langService.getLangLabelValue("LblOrderSummary").then(res => {
      this.ordersummary = res
    });
    this.langService.getLangLabelValue("LblSubTotal").then(res => {
      this.sub_toal = res
    });
    this.langService.getLangLabelValue("LblShipping_Handling").then(res => {
      this.shipping_handling = res
    });
    this.langService.getLangLabelValue("LblTax").then(res => {
      this.tax_amount = res
    });
    this.langService.getLangLabelValue("LblOrderTotal").then(res => {
      this.order_total = res
    });
    this.langService.getLangLabelValue("LblSubmitOrder").then(res => {
      this.order_submit = res
    });
    this.langService.getLangLabelValue("LblPaymentMethod").then(res => {
      this.payment_method = res
    });
    this.langService.getLangLabelValue("LblCash").then(res => {
      this.cash = res
    });
    this.langService.getLangLabelValue("LblCheck").then(res => {
      this.check = res
    });
    this.langService.getLangLabelValue("LblInvoice").then(res => {
      this.invoice_txt = res
    });
    this.langService.getLangLabelValue("LblAmount").then(res => {
      this.amount = res
    });
    this.langService.getLangLabelValue("LblAddPaymentMethod").then(res => {
      this.addpayment_method = res
    });
    this.langService.getLangLabelValue("LblReviewOrder").then(res => {
      this.order_review = res
    });
    this.langService.getLangLabelValue("LblCompleteOrder").then(res => {
      this.order_complete = res
    });
    this.langService.getLangLabelValue("LblClear").then(res => {
      this.clear = res
    });
    this.langService.getLangLabelValue("LblIAgreeToTerm&Condition").then(res => {
      this.order_terms = res
    });
    this.langService.getLangLabelValue("LblAvailableCredit").then(res => {
      this.availablecr = res
    });
    this.langService.getLangLabelValue("LblShippingInformation").then(res => {
      this.shippinginfo = res
    });
    this.langService.getLangLabelValue("LblBillingInformation").then(res => {
      this.billinginfo = res
    });
    this.langService.getLangLabelValue("LblCreditLimit").then(res => {
      this.credit_limit = res
    });
    this.langService.getLangLabelValue("LblQuantity").then(result => {
      this.quantity = result;
    });

    this.langService.getLangLabelValue("LblItem").then(result => {
      this.item_number = result;
    });
    this.langService.getLangLabelValue("Lblitems").then(result => {
      this.items = result;
    });
    this.langService.getLangLabelValue("LblPrimary").then(res => {
      this.primary = res
    });

    this.langService.getLangLabelValue("LblCheckout").then(res => {
      this.checkout = res
    });
    this.langService.getLangLabelValue("LblAddYourSignature").then(res => {
      this.addsignature = res
    });
    this.langService.getLangLabelValue("LblCityTax").then(res => {
      this.city_tax = res
    });
    this.langService.getLangLabelValue("LblStateTax").then(res => {
      this.state_tax = res
    });
    this.langService.getLangLabelValue("LblValidName").then(res => {
      this.valid_name = res
    });
    this.langService.getLangLabelValue("200_signee_name_blank").then(res => {
      this.signee_name = res
    });
    this.langService.getLangLabelValue("LblEnteredAmtCantBeLesser").then(res => {
      this.amount_check = res
    });
    this.langService.getLangLabelValue("LblPORequired").then(res => {
      this.po_required = res
    });
    this.langService.getLangLabelValue("LblItemDoesNotExist").then(res => {
      this.item_not_exist = res
    });
    this.langService.getLangLabelValue("LblEnteredAmtCantBeMoreThan").then(res => {
      this.amount_check_more = res
    });
    this.langService.getLangLabelValue("200_invalid_payment_method").then(res => {
      this.invalid_pymt_mthd = res
    });
    this.langService.getLangLabelValue("LblAddYourSignature").then(res => {
      this.add_sign = res

    });
    this.langService.getLangLabelValue("LblOnline").then(res => {
      this.online_txt = res
    });
    this.langService.getLangLabelValue("LblAddPaymentMethod").then(res => {
      this.add_payment = res
    });
    this.langService.getLangLabelValue("LblPONumber").then(res => {
      this.po_number = res
    });
    this.langService.getLangLabelValue("LblName").then(res => {
      this.name_text = res
    });
    this.langService.getLangLabelValue("200_order_placed_online").then(res => {
      this.order_msg1 = res
    });
    this.langService.getLangLabelValue("200_order_number").then(res => {
      this.order_msg2 = res
    });
    this.langService.getLangLabelValue("Lblok").then(res => {
      this.lbl_ok = res
    });
    this.langService.getLangLabelValue("LblItemUOM").then(result => {
      this.lbl_uom = result;
    });
    this.langService.getLangLabelValue("LblUOMQty").then(result => {
      this.lbl_qty = result;
    });
    this.langService.getLangLabelValue("LblYes").then(result => {
      this.lbl_yes = result;
    });
    this.langService.getLangLabelValue("LblNo").then(result => {
      this.lbl_no = result;
    });
    this.langService.getLangLabelValue("200_insufficientCredLim").then(result => {
      this.lbl_insuff = result;
    });
    this.langService.getLangLabelValue("200_online_amount_exceed").then(result => {
      this.lbl_onlineexceed = result;
    });
    this.langService.getLangLabelValue("LblTotalAmtLess").then(result => {
      this.lbl_less = result;
    });
    this.langService.getLangLabelValue("LblRemainingAmt").then(result => {
      this.lbl_remain = result;
    });
    this.langService.getLangLabelValue("LblPDFNotAvailable").then(result => {
      this.pdfnot_avail = result;

    });
    this.langService.getLangLabelValue("LblSelected").then(res => {
      this.lbl_selected = res
    });
    this.langService.getLangLabelValue("LblNoItem").then(res => {
      this.lbl_noitem = res
    });
    this.langService.getLangLabelValue("LblOpenPDF").then(res => {
      this.lbl_openpdf = res
    });

    this.langService.getLangLabelValue("200_less_pay_amount").then(res => {
      this.lbl_lesspay = res
    });
    this.langService.getLangLabelValue("200_enter_card_no").then(res => {
      this.lbl_cardnumber = res
      console.log("aaaaa"+this.lbl_cardnumber)
    });
    this.langService.getLangLabelValue("200_enter_month").then(res => {
      this.lbl_month = res
    });
    this.langService.getLangLabelValue("200_enter_year").then(res => {
      this.lbl_year = res
    });
    this.langService.getLangLabelValue("200_enter_cardcode").then(res => {
      this.lbl_cardcode = res
    });
    this.langService.getLangLabelValue("LblCardNumber").then(res => {
      this.txt_cardnumber = res
      console.log("crdtext"+this.txt_cardnumber)
    });
    this.langService.getLangLabelValue("LblExpirydate").then(res => {
      this.txt_expirydate = res
      console.log("crdtext"+this.txt_expirydate)
      
    });
    this.langService.getLangLabelValue("LblCardcode").then(res => {
      this.txt_cardcode = res
    });
    
  }

  close() {
    this.location.back();
  }
  onlyDecimalNumberKey(event) {
    this.valid_amount = false;
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  currencyInputChanged(value) {
    var num = value.replace(/[$,]/g, "");
    return Number(num);
  }

  paymentdone() {
    this.router.navigate(['/dashboard/order']);
  }

  collectPayment(form: NgForm) {

    if (this.amountOnline > 0 && !this.cardnumber) {
      this.cardnumDialog = !this.cardnumDialog;
      return true;
    }
    else if (this.amountOnline > 0 && !this.selectedMonth) {
      this.monthDialog = !this.monthDialog;
      return true;
    }
    else if (this.amountOnline > 0 && !this.selectedYear) {
      this.yearDialog = !this.yearDialog;
      return true;
    }
    else if (this.amountOnline > 0 && !this.cardcode) {
      this.cardcodeDialog = !this.cardcodeDialog;
      return true;
    }  
    // else if (this.amountOnline == this.totalAmtToBePaid) {
    //   this.proccedonlinepayment();
    // }
    else {
      this.proccedonlinepayment();
      this.valid_amount = true
    }
      
  }

  proccedonlinepayment() {
    this.IsHidden = false;
    var date = new Date();
    var miliseconds = date.getTime();
    let authoriseConfig =  JSON.parse(localStorage.getItem('AuthoriseConfigData'))
    const apiParams = {
      "createTransactionRequest": {
        "merchantAuthentication": {
          "name": authoriseConfig.provider_account,
          "transactionKey": authoriseConfig.provider_auth_key
        },
        "refId": miliseconds,
        "transactionRequest": {
          "transactionType": "authCaptureTransaction",
          "amount": this.amountOnline.toFixed(2),
          "payment": {
            "creditCard": {
              "cardNumber": this.cardnumber,
              "expirationDate":this.selectedYear+"-"+this.selectedMonth,
              "cardCode": this.cardcode
            }
          },
          "lineItems": {
          },
          "tax": {
            "amount": '0.00',
            "name": "level2 tax name",
            "description": "level2 tax"
          },
          "duty": {
            "amount": "8.55",
            "name": "duty name",
            "description": "duty description"
          },
          "shipping": {
            "amount": 0,
            "name": "level2 tax name",
            "description": "level2 tax"
          },
          "poNumber": '909',
          "customer": {
            "id": this.customerdetailsData.customer_number
          },
          "billTo": {
            //  "firstName": this.customerdetailsData.billing_address.billingAdd1,
            // "lastName": "Johnson",
            // "company": "Souveniropolis",
            "address": '',
            "city": '',
            "state": '',
            "zip": ''
            // "country": "USA"
          },
          "shipTo": {
            //  "firstName": this.selectedShippingAddress.addressL1,
            // "lastName": "Bayles",
            // "company": "Thyme for Tea",
            "address":'',
            "city": '',
            "state": '',
            "zip": '',
            // "country": "USA"
          },
          "customerIP": this.ipaddr.ip,
          "transactionSettings": {
            "setting": {
              "settingName": "testRequest",
              "settingValue": "false"
            }
          },
          "userFields": {
            "userField": [
              {
                "name": "MerchantDefinedFieldName1",
                "value": "MerchantDefinedFieldValue1"
              },
              {
                "name": "favorite_color",
                "value": "blue"
              }
            ]
          }
        }
      }
    };
    let that = this;
    return this.http.post('https://apitest.authorize.net/xml/v1/request.api', apiParams).subscribe(res => {
      this.output = res.json();
      if (this.output) {
        if (this.output.messages.resultCode == "Ok") {
          that.saveDataToBackend(this.output.refId);
        } else {
          that.IsHidden = true;
          this.ermsg = this.output.transactionResponse.errors[0].errorText;
          console.log("ghjjh" + this.ermsg);
          this.paymentfailDialog = !this.paymentfailDialog;
          return true;
        }
      }
    })
  }

  successfulPaymt(){
      this.router.navigate(['/dashboard/invoice'])
      this.localStorage.removeItem('payAtm').subscribe(res =>{
      })
  }

  saveDataToBackend(transactionId) {
      let payment_data = {};
      let requestArray = [];
      for (let i = 0; i < this.totalOrders.length; i++) {
        payment_data = {};
        let currentOrder = this.totalOrders[i];
        let order_number = currentOrder.order_number;
        let invoice_number = currentOrder.invoice_number;
        let payment_amount = currentOrder.outstanding;
        // let payment_type = "online";
        // let cheque_num = "";
        payment_data['order_number'] = order_number;
        payment_data['invoice_num'] = invoice_number;
        payment_data['payment_type'] = "online";
        payment_data["payment_amt"] = this.amountOnline.toFixed(2);
        payment_data["transactionId"] = transactionId;
        payment_data['cheque_num'] = ""
        requestArray.push(payment_data)
      }

      
      this.restApi.collectTotalPayment(requestArray).subscribe(resp => {
        let res1 = JSON.parse(resp._body) 
        let res = res1.response
        if (res) {
          if (res.status_code == 200 && res.error_message == "") {
            this.collectDialog = !this.collectDialog;
            // this.paymentsuccessDialog = !this.paymentsuccessDialog; 
          }
          else
            this.errorDialog = !this.errorDialog
            this.errorMsg = res.error_message;
            // alert(res.error_message)
        }
        this.IsHidden = true;
      })
  }
}




// WEBPACK FOOTER //
// ./src/app/collectpayment/collectpayment.component.ts